import { observer } from "mobx-react-lite";
import { withLang, withT } from "./tools";
import { useReactive, useRequest } from "ahooks";
import { getIeoList } from "../../../api/xt-launchpad";
import { useMemo } from "react";
import BigNumber from "bignumber.js";
import useCountDown from "../../../hooks/useCountDown";
import { utcToLocal } from '@/utils/date';
import { PirmaryBtn } from "./components/primaryBtn";
import { withRouter } from "next/router";
import { getPageDetailUrl } from "./configs";
import { BuyInfoTag } from "./components/buyInfoTag";
import StatusLabel from "./components/statusLabel";

const limitShowLength = 6;

const PageInprogress = ({
  t,
}) => {
  const state = useReactive({
    counterStatusChange: false,
    limitShow: true,
  });

  const {
    data = [],
  } = useRequest(() => getIeoList());

  const [notFinishList, finishedList] = useMemo(() => {
    const now = Date.now();

    const notBeginList = data
      .filter(item => new BigNumber(item.startTime).gt(now)).sort((a, b) => {
        if (new BigNumber(a.startTime).gt(b.startTime)) {
          return 1;
        } else {
          return -1;
        }
      });
    const notFinishList = data
      .filter(item => new BigNumber(item.startTime).lte(now))
      .filter(item => new BigNumber(item.endTime).gte(now)).sort((a, b) => {
        if (new BigNumber(a.endTime).gt(b.endTime)) {
          return 1;
        } else {
          return -1;
        }
      });
    const finishedList = data
      .filter(item => new BigNumber(item.endTime).lt(now)).sort((a, b) => {
        if (new BigNumber(a.endTime).lt(b.endTime)) {
          return 1;
        } else {
          return -1;
        }
      });

    return [[...notFinishList, ...notBeginList], finishedList];
  }, [data, state.counterStatusChange]);

  const onInprogressCounterFinished = () => {
    state.counterStatusChange = !state.counterStatusChange;
  };

  const onViewMoreClick = () => {
    state.limitShow = false;
  }

  return (
    <div className="pt-[51px] sm:pt-0">
      {notFinishList.map(item => <InprogressContent className="sm:pb-[20px]" onFinish={onInprogressCounterFinished} key={item.id} projectItem={item} />)}
      <h3 className="pt-[15px] sm:pt-0 mb-[21px] text-[22px] sm:text-[18px] font-[600] sm:font-medium text-[#333] leading-[1.5]">{t('listing.Ended')}（{finishedList.length}）</h3>
      <div className="grid grid-cols-3 gap-[30px] sm:grid-cols-1 sm:gap-[15px]">
        {finishedList
          .filter((_, idx) => state.limitShow ? idx < limitShowLength : true)
          .map(item => <FinishedContent key={item.id} projectItem={item} />)}
      </div>

      {(finishedList.length > 6 && state.limitShow) ? <ViewMoreBtn className="mt-[30px]" onClick={onViewMoreClick} /> : null}
    </div>
  );
};

export default observer(withT(PageInprogress));

const FinishedContent = withT(withRouter(({
  t,
  router,
  projectItem = {},
}) => {
  const {
    currencyPay,
    posterImg,
    configFormName,
    currencyReceive,
    name,
    startTime,
    id,
    endTime,
    totals,
  } = projectItem;

  const onViewDetailClick = () => {
    router.push(getPageDetailUrl(id));
  };

  return (
    <div
      style={{
        boxShadow: '0 2px 4px 0 rgba(64,71,90,.1)',
        border: '1px solid #f0f2f7',
      }}
      className="p-[25px] rounded-[14px] sm:rounded-[5px] sm:p-[17px]"
    >
      <section className="relative overflow-hidden rounded-[6px] mb-[8px] h-[154px] sm:h-[135px]">
        {configFormName ? <BuyInfoTag>{configFormName}</BuyInfoTag> : null}
        <TransitionImg onClick={onViewDetailClick} src={posterImg} />
      </section>
      <div className="text-[14px] text-[#8f8e92] pt-[10px] flex justify-between">
        <span>{t('cmpt.totalSupply')}</span>
        <span className="text-[#383742] font-medium">{totals} {currencyReceive?.toUpperCase()}</span>
      </div>
      <div className="text-[14px] text-[#8f8e92] pt-[10px] flex justify-between">
        <span>{t('group.StartTime')}</span>
        <span className="text-[#383742] font-medium">{utcToLocal(startTime)}</span>
      </div>
      <div className="text-[14px] text-[#8f8e92] pt-[10px] flex justify-between">
        <span>{t('group.EndTime')}</span>
        <span className="text-[#383742] font-medium">{utcToLocal(endTime)}</span>
      </div>
    </div>
  )
}));

const InprogressContent = withT(withRouter(({
  t,
  router,
  onFinish,
  projectItem = {},
}) => {
  const {
    currencyPay,
    posterImg,
    configFormName,
    currencyReceive,
    name,
    startTime,
    id,
    endTime,
    totals,
  } = projectItem;

  const hasBegin = new BigNumber(startTime).lt(Date.now());
  const status = hasBegin ? 'inprogress' : 'coming';
  const counterLabel = hasBegin ? 'group.ending' : 'group.starting';

  const { day, hour, min, sec } = useCountDown({
    value: hasBegin ? endTime : startTime,
    onFinish,
  });

  const onViewDetailClick = () => {
    router.push(getPageDetailUrl(id));
  };

  return (
    <div className="h-[280px] sm:h-[316px] mb-[30px] sm:mb-[20px] overflow-hidden flex sm:flex-col rounded-[14px] sm:rounded-[7px] shadow-[0_4px_20px_0_#ececec]">
      <section className="relative overflow-hidden w-[600px] sm:w-full sm:h-[156px]">
        {configFormName ? <BuyInfoTag>{configFormName}</BuyInfoTag> : null}
        <TransitionImg className="sm:h-[156px] sm:object-cover" onClick={onViewDetailClick} src={posterImg} />
      </section>
      <section className="p-[30px_80px] sm:p-[15px_20px] w-[600px] sm:w-full overflow-hidden">
        <div className="sm:flex sm:justify-between">
          <h3 className="mb-[10px] font-[700] text-[26px] sm:text-[18px] sm:font-medium text-[#383742]">{name}</h3>
          <StatusLabel status={status} />
        </div>
        <div className="mt-[30px] sm:mt-0 flex justify-between mb-[12px] text-[#8f8e92] text-[18px] sm:text-[13px]">
          <span>{t('cmpt.totalSupply')}</span>
          <span className="text-primary">{totals} {currencyReceive?.toUpperCase()}</span>
        </div>
        <div className="flex justify-between mb-[12px] text-[#8f8e92] text-[18px] sm:text-[13px] whitespace-nowrap">
          <span>{t(counterLabel)}</span>
          <span className="text-[#383742]">{`${day}${t('etf.periodDay')} ${hour}${t('etf.periodHour')} ${min}${t('etf.periodMin')} ${sec}${t('listing.Second')}`}</span>
        </div>
        <PirmaryBtn onClick={onViewDetailClick} type="primary" color="#fff" className="mt-[10px] sm:mt-0 h-[36px] sm:h-[34px] w-full rounded-[3px] sm:text-[12px]">{t('group.ViewDetails')}</PirmaryBtn>
      </section>
    </div>
  );
}));

export const ViewMoreBtn = withT(({
  t,
  className,
  ...restProps
}) => {

  return (
    <span
      style={{
        transform: 'translateX(-50%)',
      }}
      className={"text-[#383742] hover:text-primary text-[14px] underline underline-offset-4 cursor-pointer font-medium inline-block relative left-1/2" + (className ? ` ${className}` : '')}
      {...restProps}
    >{t('cmpt.viewmore')}</span>
  );
});

export const TransitionImg = ({
  className,
  src,
  ...restProps
}) => {

  return (
    <>
      <style>
        {`.img-scale:hover {
          transform: matrix(1.1, 0, 0, 1.1, 0, -10);
        }`}
      </style>
      {src ? <img
        className={"border-none transition-all duration-200 ease-in-out hover:scale-125 cursor-pointer w-full h-full object-cover max-w img-scale" + (className ? ` ${className}` : '')}
        {...restProps}
        src={src}
        alt=""
      /> : <div
        className={"border-none transition-all duration-200 ease-in-out hover:scale-125 cursor-pointer w-full h-full object-cover max-w img-scale" + (className ? ` ${className}` : '')}
        {...restProps}
      ></div>}
    </>
  );
};
